module.exports = __webpack_public_path__ + "static/media/ballSliding.2700bbfa.mp3";